import React__default, { useRef } from 'react';
import '../NvModal/NvModal.esm.js';
import { useNvModal } from '../NvModal/NvModal.hooks.esm.js';
import NvTagsBody from './NvTagsBody/NvTagsBody.esm.js';
import NvTagsContextProvider from './NvTagsContext/NvTagsContextProvider.esm.js';

var NvTags = function (_a) {
    var onFinish = _a.onFinish, modalTitle = _a.modalTitle, modalButtonText = _a.modalButtonText, children = _a.children, buttonAddText = _a.buttonAddText, size = _a.size, showClearButton = _a.showClearButton, readonly = _a.readonly, initialValues = _a.initialValues, modalBodyFullWidth = _a.modalBodyFullWidth;
    var ref = useRef(null);
    var _b = useNvModal(ref), closeModalDialog = _b.closeModalDialog, openModalDialog = _b.openModalDialog;
    return (React__default.createElement(NvTagsContextProvider, { closeModal: closeModalDialog, initialValues: initialValues, onFinish: onFinish, openModal: openModalDialog },
        React__default.createElement(NvTagsBody, { buttonAddText: buttonAddText, modalBodyFullWidth: modalBodyFullWidth, modalButtonText: modalButtonText, modalTitle: modalTitle, readonly: readonly, ref: ref, showClearButton: showClearButton, size: size }, children)));
};

export { NvTags as default };
//# sourceMappingURL=NvTags.esm.js.map
